import { IOWidget, nothing, Updater } from 'widgets-for-react'
import { PublicSiteState } from '../../../../../../root/state'
import { BlockData, CMSState } from '../../../cms/blocks/types.gen'
import { CustomBlock } from '../../../drupal/types_and_parser/custom_blocks.mod'
import { Block } from '../../../drupal/types_and_parser/standard_blocks.gen'
import { archivedDownloadsBlock, archivedDownloadsBlockProps } from './widgets/archivedDownloadsBlock'
import {
  campaignMonitorBlock,
  CampaignMonitorBlockProps,
  CampaignMonitorBlockStyle
} from './widgets/campaignMonitorBlock'
import { carrouselBlock, carrouselBlockProps, carrouselBlockStyle } from './widgets/carrouselBlock'
import { colorCtaBlock, ColorCtaBlockProps } from './widgets/colorCtaBlock'
import { contactBlock, contactBlockProps, contactBlockStyle } from './widgets/contactBlock'
import { developmentBlock, developmentBlockProps, developmentBlockStyle } from './widgets/developmentBlock'
import { DoubleTextImageBlock, DoubleTextImageBlockProps, DoubleTextImageBlockStyle } from './widgets/doubleTextImage'
import { expandBlock, expandBlockProps } from './widgets/expandBlock.mod'
import { formBlock, formBlockProps, formBlockStyle } from './widgets/formBlock'
import { HubSpotFrameBlockStyle, hubspotIFrameBlock, HubspotIFrameProps } from './widgets/hubspotIFrame'
import { IframeCodeBlock, IframeCodeBlockProps, IframeCodeBlockStyle } from './widgets/iframeCodeBlock'
import { Image360Block, Image360BlockProps, Image360BlockStyle } from './widgets/image360Block'
import { jobAlertBlockProps, jobAlertBlockStyle, jobAlertsBlock } from './widgets/jobAlertsBlock'
import { MagazineEmbedBlock, MagazineEmbedBlockProps, MagazineEmbedBlockStyle } from './widgets/magazineEmbedBlock'
import { officeBlock, officeBlockProps } from './widgets/officeBlock'
import {
  otherKeyProjectsBlock,
  otherKeyProjectsBlockProps,
  otherKeyProjectsBlockStyle
} from './widgets/otherKeyProjectsBlock'
import { personBlock, personBlockProps, personBlockStyle } from './widgets/personBlock.mod'
import { pressContactBlock, PressContactBlockProps, PressContactBlockStyle } from './widgets/pressContactBlock'
import { pressReleasesBlock, pressReleasesBlockProps, pressReleasesBlockStyle } from './widgets/pressReleasesBlock'
import { relatedContentBlock, relatedContentBlockProps, relatedContentBlockStyle } from './widgets/relatedContentBlock'
import { storiesBlock, storiesBlockProps, storiesBlockStyle } from './widgets/storiesBlock.mod'
import { textBlock, textBlockProps } from './widgets/textBlock.mod'
import { textImageBlock, textImageBlockProps, textImageBlockStyle } from './widgets/textImageBlock.mod'
import { timelineBlock, timelineBlockProps, timelineBlockStyle } from './widgets/timelineBlock.mod'
import { updateBlock, updateBlockProps, updateBlockStyle } from './widgets/updateBlock.mod'

//add here your custom blocks definitions

export type CustomBlockData =
  | colorCtaBlock
  | personBlock
  | carrouselBlock
  | formBlockData
  | hubspotIFrameData
  | storiesBlockData
  | timelineBlockData
  | textImageBlockData
  | textBlockData
  | pressReleasesBlockData
  | expandBlockData
  | doubleTextImageData
  | archivedDownloadsBlockData
  | campaignMonitorBlock
  | Image360Data
  | pressContactBlockData
  | updateBlockData
  | officeBlockData
  | contactBlockData
  | jobAlertBlockData
  | developmentBlockData
  | relatedContentBlockData
  | otherKeyProjectsBlockData
  | iframeCodeBlockData
  | magazineEmbedBlockData

export function isCustomBlockData(b: BlockData | CustomBlockData): b is CustomBlockData {
  return (
    b.kind == 'ctaBlock' ||
    b.kind == 'personBlock' ||
    b.kind == 'carrouselBlock' ||
    b.kind == 'formBlock' ||
    b.kind == 'pressReleasesBlock' ||
    b.kind == 'hubspotIFrameBlock' ||
    b.kind == 'storiesBlock' ||
    b.kind == 'timelineBlock' ||
    b.kind == 'textBlock' ||
    b.kind == 'textImageBlock' ||
    b.kind == 'expandBlock' ||
    b.kind == 'doubleTextImageBlock' ||
    b.kind == 'campaignMonitorBlock' ||
    b.kind == 'downloadsBlock' ||
    b.kind == 'Image360Block' ||
    b.kind == 'pressContactBlock' ||
    b.kind == 'updateBlock' ||
    b.kind == 'officeBlock' ||
    b.kind == 'contactBlock' ||
    b.kind == 'jobAlertBlock' ||
    b.kind == 'developmentBlock' ||
    b.kind == 'relatedContentBlock' ||
    b.kind == 'otherKeyProjectsBlock' ||
    b.kind == 'iframeCodeBlock' ||
    b.kind == 'magazineEmbedBlock'
  )
}

export function isCustomBlock<s, i>(b: Block | CustomBlock): b is CustomBlock {
  return (
    b.kind == 'cta' ||
    b.kind == 'personBlock' ||
    b.kind == 'grid_blocks_image' ||
    b.kind == 'grid_blocks_plain' ||
    b.kind == 'iframe' ||
    b.kind == 'text_with_image' ||
    b.kind == 'form' ||
    b.kind == 'campaign_manager' ||
    b.kind == 'downloads' ||
    b.kind == '360_building_block' ||
    b.kind == 'press' ||
    b.kind == 'office' ||
    b.kind == 'updates' ||
    b.kind == 'expandable_content_blocks' ||
    b.kind == 'contact' ||
    b.kind == 'job_alert' ||
    b.kind == 'development_block' ||
    b.kind == 'related_content_load_more' ||
    b.kind == 'extra_navigational_element' ||
    b.kind == 'iframe_code' ||
    b.kind == 'magazine_embed'
  )
}

export function renderCustomBlock(
  block: CustomBlockData,
  public_state: PublicSiteState,
  set_public_site_state: (output: Updater<PublicSiteState>) => void
): IOWidget<CMSState, Updater<CMSState>> {
  return (s0) => {
    if (block.kind == 'personBlock') {
      return personBlock(block.value[0], { style: block.value[1] })(s0)(public_state)
    } else if (block.kind == 'pressReleasesBlock') {
      return pressReleasesBlock(block.value[0], { style: block.value[1] })(s0)(public_state)
    } else if (block.kind == 'campaignMonitorBlock') {
      return campaignMonitorBlock(block.value[0], { style: block.value[1] })(s0)(public_state)
    } else if (block.kind == 'storiesBlock') {
      return storiesBlock(block.value[0], { style: block.value[1] })(s0)(public_state)
    } else if (block.kind == 'textImageBlock') {
      return textImageBlock(block.value[0], { style: block.value[1] })(s0)(public_state)
    } else if (block.kind == 'textBlock') {
      return textBlock(block.value)(s0)(public_state)
    } else if (block.kind == 'timelineBlock') {
      return timelineBlock(block.value[0], { style: block.value[1] })(s0)(public_state)
    } else if (block.kind == 'carrouselBlock') {
      return carrouselBlock(block.value[0], { style: block.value[1] })(s0)(public_state)
    } else if (block.kind == 'formBlock') {
      return formBlock(block.value[0], { style: block.value[1] })(s0)(public_state)
    } else if (block.kind == 'hubspotIFrameBlock') {
      return hubspotIFrameBlock(block.value[0], { style: block.value[1] })
    } else if (block.kind == 'ctaBlock') {
      return colorCtaBlock(block.value)(s0)
    } else if (block.kind == 'expandBlock') {
      return expandBlock(block.value)(s0)(public_state)
    } else if (block.kind == 'doubleTextImageBlock') {
      return DoubleTextImageBlock(block.value[0], { style: block.value[1] })(s0)
    } else if (block.kind == 'pressContactBlock') {
      return pressContactBlock(block.value[0], { style: block.value[1] })(s0)(public_state)
    } else if (block.kind == 'downloadsBlock') {
      return archivedDownloadsBlock(block.value)(s0)(public_state)
    } else if (block.kind == 'Image360Block') {
      return Image360Block(block.value[0], { style: block.value[1] })(s0)
    } else if (block.kind == 'updateBlock') {
      return updateBlock(block.value[0], { style: block.value[1] })(public_state)
    } else if (block.kind == 'officeBlock') {
      return officeBlock(block.value)(s0)
    } else if (block.kind == 'contactBlock') {
      return contactBlock(block.value[0], { style: block.value[1] })(s0)
    } else if (block.kind == 'jobAlertBlock') {
      return jobAlertsBlock(block.value[0], { style: block.value[1] })(s0)(public_state)
    } else if (block.kind == 'developmentBlock') {
      return developmentBlock(block.value[0], { style: block.value[1] })(s0)
    } else if (block.kind == 'relatedContentBlock') {
      return relatedContentBlock(block.value[0], { style: block.value[1] })(public_state)
    } else if (block.kind == 'otherKeyProjectsBlock') {
      return otherKeyProjectsBlock(block.value[0], { style: block.value[1] })(s0)(public_state)
    } else if (block.kind == 'iframeCodeBlock') {
      return IframeCodeBlock(block.value[0], { style: block.value[1] })(s0, set_public_site_state)(public_state)
    } else if (block.kind == 'magazineEmbedBlock') {
      return MagazineEmbedBlock(block.value[0], { style: block.value[1] })(public_state)
    } else {
      return nothing()
    }
  }
}

export type colorCtaBlock = { kind: 'ctaBlock'; value: ColorCtaBlockProps }
export type personBlock = { kind: 'personBlock'; value: [personBlockProps, personBlockStyle] }
export type carrouselBlock = { kind: 'carrouselBlock'; value: [carrouselBlockProps, carrouselBlockStyle] }
export type hubspotIFrameData = { kind: 'hubspotIFrameBlock'; value: [HubspotIFrameProps, HubSpotFrameBlockStyle] }
export type formBlockData = { kind: 'formBlock'; value: [formBlockProps, formBlockStyle] }
export type storiesBlockData = { kind: 'storiesBlock'; value: [storiesBlockProps, storiesBlockStyle] }
export type timelineBlockData = { kind: 'timelineBlock'; value: [timelineBlockProps, timelineBlockStyle] }
export type textImageBlockData = { kind: 'textImageBlock'; value: [textImageBlockProps, textImageBlockStyle] }
export type textBlockData = { kind: 'textBlock'; value: textBlockProps }
export type pressReleasesBlockData = {
  kind: 'pressReleasesBlock'
  value: [pressReleasesBlockProps, pressReleasesBlockStyle]
}
export type expandBlockData = { kind: 'expandBlock'; value: expandBlockProps }
export type doubleTextImageData = {
  kind: 'doubleTextImageBlock'
  value: [DoubleTextImageBlockProps, DoubleTextImageBlockStyle]
}
export type archivedDownloadsBlockData = { kind: 'downloadsBlock'; value: archivedDownloadsBlockProps }
export type campaignMonitorBlock = {
  kind: 'campaignMonitorBlock'
  value: [CampaignMonitorBlockProps, CampaignMonitorBlockStyle]
}
export type Image360Data = { kind: 'Image360Block'; value: [Image360BlockProps, Image360BlockStyle] }
export type pressContactBlockData = {
  kind: 'pressContactBlock'
  value: [PressContactBlockProps, PressContactBlockStyle]
}
export type updateBlockData = { kind: 'updateBlock'; value: [updateBlockProps, updateBlockStyle] }
export type officeBlockData = { kind: 'officeBlock'; value: officeBlockProps }
export type contactBlockData = { kind: 'contactBlock'; value: [contactBlockProps, contactBlockStyle] }
export type jobAlertBlockData = { kind: 'jobAlertBlock'; value: [jobAlertBlockProps, jobAlertBlockStyle] }
export type developmentBlockData = { kind: 'developmentBlock'; value: [developmentBlockProps, developmentBlockStyle] }
export type relatedContentBlockData = {
  kind: 'relatedContentBlock'
  value: [relatedContentBlockProps, relatedContentBlockStyle]
}
export type otherKeyProjectsBlockData = {
  kind: 'otherKeyProjectsBlock'
  value: [otherKeyProjectsBlockProps, otherKeyProjectsBlockStyle]
}
export type iframeCodeBlockData = { kind: 'iframeCodeBlock'; value: [IframeCodeBlockProps, IframeCodeBlockStyle] }
export type magazineEmbedBlockData = {
  kind: 'magazineEmbedBlock'
  value: [MagazineEmbedBlockProps, MagazineEmbedBlockStyle]
}
